module.exports = new __parcel__URL__("level_2_tab_inactive.0c65153d.png").toString();